import React from 'react';
import { Row, Col, Input, Select, InputNumber, Radio, DatePicker } from 'antd';
import ContractAmount from './ContractAmount';
import Text from '../../../basicElement/Text';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import { getMatchOption, generateOptions } from '../../../shared/selectFn';
import format from '../../../shared/format';
import API_URL from '../../../../common/url';
import { Default, MedicineType, RequestStatus, ContractNature } from '../constants';

const width = 240;
const { Group } = Radio;
const { Option } = Select;
const dateFormat = "YYYY-MM-DD";
const MedicineTypeOption = generateOptions(MedicineType);
const RequestStatusOption = generateOptions(RequestStatus);
const DefaultOption = generateOptions(Default);
const DefaultRadio = generateOptions(Default, 'radio');
const ContractNatureOption = generateOptions(ContractNature);

function UpdateView (props) {
    const {
        config, data, onChange, stageList, byStageList, testeeTypeList, typeList, businessList,
        signingUnit, contractTypeList, currencyList
    } = props;
    const { investigationStageIds, investigationByStageIds } = data;
    const { typeValue: stageName } = getMatchOption(stageList, 'typeConfigureId', investigationStageIds);
    
    // 没选阶段时，单独判断；选择一个时，判断是否是多选项；选择两个以上，默认可多选
    let multiplable = true;
    if (investigationByStageIds && !investigationByStageIds.includes(',')) {
        const { isMultipleChoice } = getMatchOption(byStageList, 'investigationByStageId', investigationByStageIds);
        multiplable = isMultipleChoice == 1;
    }

    const { currencyCode } = getMatchOption(currencyList, 'currencyExchangeRateId', data.currencyExchangeRateId);
    const isCNY = currencyCode === 'CNY';

    const required = config.add || config.edit;

    const { typeValue, childList: secondLineList = [] } = getMatchOption(businessList, 'typeConfigureId', data.lineOfBusinessId);
    const settings = {};
    const isMultiple = !(typeValue === '肿瘤' || typeValue === '非肿瘤' || typeValue === '综合');
    if (isMultiple) {
        settings.mode = 'multiple';
    }
    const belongingToUnit = getMatchOption(signingUnit, 'unitOfSigningId', data.signingUnit).belongings || [];

    const stageOption = stageList.map(d => <Option key={d.typeConfigureId}>{d.typeValue}</Option>);
    const byStageOption = byStageList.map(d => <Option key={d.investigationByStageId} disabled={investigationByStageIds ? multiplable ? d.isMultipleChoice == 0 : d.isMultipleChoice == 1 : false}>{d.investigationByStageName}</Option>);
    const testeeTypeOption = testeeTypeList.map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
    const typeOption = typeList.map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
    const businessOption = businessList.map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
    const secondLineOption = secondLineList.map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
    const signingUnitOption = signingUnit.map(i => <Option key={i.unitOfSigningId}>{i.unitOfSigningName}</Option>);
    const belongingToUnitOption = belongingToUnit.map(i => <Option key={i.unitOfBelongingId}>{i.unitOfBelongingName}</Option>);
    const contractTypeOption = contractTypeList.map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
    const currencyOption = currencyList.map(i => <Option key={i.currencyExchangeRateId}>{format('joint', i.currencyName, i.currencyCode, 'roundBrackets')}</Option>);

    return (
        <div className="historyContractRecordUpdate">
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>JDE主项目号</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Input
                            placeholder='请输入'
                            style={{ width }}
                            value={data.mainInvestigationJdeContractCode}
                            onChange={e => onChange(e.target.value, 'mainInvestigationJdeContractCode')}
                        />
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>项目简称</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Input
                            placeholder='请输入'
                            style={{ width }}
                            value={data.investigationName}
                            onChange={e => onChange(e.target.value, 'investigationName')}
                        />
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>项目编号</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Input
                            placeholder='请输入'
                            style={{ width }}
                            value={data.investigationCode}
                            onChange={e => onChange(e.target.value, 'investigationCode')}
                        />
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>项目阶段</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            mode="multiple"
                            allowClear={true}
                            placeholder='请选择'
                            filterOption={false}
                            disabled={stageName === '项目终止'}
                            value={format('toArray', data.investigationStageIds)}
                            style={{ width }}
                            onChange={value => onChange(value, 'investigationStageIds')}
                        >
                            {stageOption}
                        </Select>
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>疾病</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width }}
                            placeholder="输入名称检索"
                            value={data.diseaseName}
                            params={{ limit: 20 }}
                            url={API_URL.common.queryAllDiseaseList}
                            config={{ id: 'diseaseId', name: 'diseaseName', show: 'disease' }}
                            onChange={(option) => onChange(option, 'disease')}
                        />
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>项目领域</Text>
                    </Col>
                    <Col span={15} offset={1}>{data.investigationAreaName}</Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>研究产品类型</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width }}
                            value={data.investigationMedicineType}
                            onChange={value => onChange(value, 'investigationMedicineType')}
                        >
                            {MedicineTypeOption}
                        </Select>
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>项目分期</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            mode="multiple"
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width }}
                            disabled={!data.investigationMedicineType}
                            value={format('toArray', data.investigationByStageIds)}
                            onChange={value => onChange(value, 'investigationByStageIds')}
                        >
                            {byStageOption}
                        </Select>
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>受试者类型</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width }}
                            value={format('toString', data.testeeTypeId)}
                            onChange={value => onChange(value, 'testeeTypeId')}
                        >
                            {testeeTypeOption}
                        </Select>
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>项目分类</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width }}
                            value={format('toString', data.typeId)}
                            onChange={value => onChange(value, 'typeId')}
                        >
                            {typeOption}
                        </Select>
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>项目关闭申请情况</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width }}
                            value={data.investigationRemittanceCompletedInfo}
                            onChange={value => onChange(value, 'investigationRemittanceCompletedInfo')}
                        >
                            {RequestStatusOption}
                        </Select>
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>申办方</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <SearchRetrieve
                            keyword='customerCompanyName'
                            style={{ width }}
                            placeholder="输入名称检索"
                            value={data.investigationSponsorName}
                            params={{ limit: 20, natureName: '申办方' }}
                            url={API_URL.investigation.queryCustomerCompanyByName}
                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                            onChange={option => onChange(option, 'investigationSponsor')}
                        />
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>PM</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width }}
                            placeholder="输入姓名/工号检索"
                            value={data.pmUserName}
                            params={{ limit: 20, workStatus: 'ALL' }}
                            url={API_URL.investigation.queryUserByKey}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => onChange(option, 'pmUser')}
                        />
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>BD</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width }}
                            placeholder="输入姓名/工号检索"
                            value={data.bdUserName}
                            params={{ limit: 20, workStatus: 'ALL' }}
                            url={API_URL.investigation.queryUserByKey}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => onChange(option, 'bdUser')}
                        />
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>JDE项目号</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Input
                            placeholder='请输入'
                            style={{ width }}
                            value={data.investigationJdeContractCode}
                            onChange={e => onChange(e.target.value, 'investigationJdeContractCode')}
                        />
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>合同编号</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Input
                            placeholder='C+5位数字，如C10002'
                            style={{ width }}
                            value={data.investigationJdeContractNumber}
                            onChange={e => onChange(e.target.value, 'investigationJdeContractNumber')}
                        />
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>名称(ProjectID)</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Input
                            placeholder='请输入'
                            style={{ width }}
                            value={data.projectIdName}
                            onChange={e => onChange(e.target.value, 'projectIdName')}
                        />
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>业务线</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width }}
                            value={format('toString', data.lineOfBusinessId)}
                            onChange={value => onChange(value, 'lineOfBusinessId')}
                        >
                            {businessOption}
                        </Select>
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>执行业务线二级分类</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            {...settings}
                            allowClear={true}
                            placeholder="请选择"
                            disabled={!data.lineOfBusinessId || !secondLineList.length}
                            style={{ width }}
                            value={
                                isMultiple ?
                                    format('toArray', data.secondLineIds)
                                :
                                    format('toString', data.secondLineIds)
                            }
                            onChange={value => onChange(value, 'secondLineIds')}
                        >
                            {secondLineOption}
                        </Select>
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>类别码13</Text>
                    </Col>
                    <Col span={15} offset={1}>{data.categoryCodeName13}</Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>合同签署单位</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width }}
                            value={format('toString', data.signingUnit)}
                            onChange={value => onChange(value, 'signingUnit')}
                        >
                            {signingUnitOption}
                        </Select>
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>收入归属单位</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width }}
                            disabled={!data.signingUnit}
                            value={format('toString', data.belongingToUnit)}
                            onChange={value => onChange(value, 'belongingToUnit')}
                        >
                            {belongingToUnitOption}
                        </Select>
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>客户全名</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <SearchRetrieve
                            keyword='customerCompanyName'
                            style={{ width }}
                            placeholder="输入名称检索"
                            params={{ limit: 20 }}
                            value={data.customerCompanyName}
                            url={API_URL.investigation.queryCustomerCompanyByName}
                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                            onChange={(option) => onChange(option, 'customerCompany')}
                        />
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>客户JDE号</Text>
                    </Col>
                    <Col span={15} offset={1}>{data.customerJdeCode}</Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>BA</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <SearchRetrieve
                            keyword='keyWord'
                            style={{ width }}
                            placeholder="输入姓名/工号检索"
                            value={data.baUserName}
                            params={{ limit: 20, roleCodes: 'BA,BAL', workStatus: 'ALL' }}
                            url={API_URL.teaching.queryEmpListByRoleCode}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={(option) => onChange(option, 'baUser')}
                        />
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>计收入确认方式</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width}}
                            value={format('toString', data.contractTypeId)}
                            onChange = {value => onChange(value, 'contractTypeId')}
                        >
                            {contractTypeOption}
                        </Select>
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>发票税率</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <InputNumber
                            max={100}
                            precision={2}
                            placeholder="请输入"
                            style={{width}}
                            value={data.invoiceRate}
                            onChange={value => onChange(value, 'invoiceRate')}
                        />&nbsp; %
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>合同是否签署完成</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width}}
                            value={format('toString', data.investigationJdeContractIsSigned)}
                            onChange = {value => onChange(value, 'investigationJdeContractIsSigned')}
                        >
                            {DefaultOption}
                        </Select> 
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>合同中是否明标合同金额</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Group
                            value={format('toString', data.investigationJdeContractIsSpecifiesAmount)}
                            onChange={e => onChange(e.target.value, 'investigationJdeContractIsSpecifiesAmount')}
                        >
                            {DefaultRadio}
                        </Group>
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>币种</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width }}
                            value={format('toString', data.currencyExchangeRateId)}
                            onChange={value => onChange(value, 'currencyExchangeRateId')}
                        >
                            {currencyOption}
                        </Select>
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>汇率</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <InputNumber
                            precision={4}
                            placeholder="请输入"
                            style={{ width }}
                            disabled={isCNY}
                            value={data.exchangeRate}
                            onChange={value => onChange(value, 'exchangeRate')}
                        />
                    </Col>
                </Col>
            </Row>
            <ContractAmount
                data={data}
                width={width}
                asterisk={required}
                currencyList={currencyList}
                onChange={onChange}
            />
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>合同开始时间</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <DatePicker
                            placeholder="请选择"
                            style={{ width }}
                            format={dateFormat}
                            value={format('toMoment', data.startTime)}
                            onChange={(date, dateString) => onChange(dateString, "startTime")}
                        />
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>合同结束时间</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <DatePicker
                            placeholder="请选择"
                            style={{ width }}
                            format={dateFormat}
                            value={format('toMoment', data.endTime)}
                            onChange={(date, dateString) => onChange(dateString, "endTime")}
                        />
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text asterisk={required} colon={true}>合同性质</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width }}
                            value={data.contractNature}
                            onChange={value => onChange(value, 'contractNature')}
                        >
                            {ContractNatureOption}
                        </Select>
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>JDE发号时间</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <DatePicker
                            placeholder="请选择"
                            style={{ width }}
                            format={dateFormat}
                            value={format('toMoment', data.jdeApplyTime)}
                            onChange={(date, dateString) => onChange(dateString, "jdeApplyTime")}
                        />
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>备注</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Input
                            placeholder='请输入'
                            style={{ width }}
                            value={data.comments}
                            onChange={e => onChange(e.target.value, 'comments')}
                        />
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>FTE单价(含税)(元)</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <InputNumber
                            precision={2}
                            placeholder="请输入"
                            style={{width}}
                            value={data.fteUnitPrice}
                            onChange={value => onChange(value, 'fteUnitPrice')}
                        />
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Col span={8}>
                        <Text colon={true}>合同请款完成情况</Text>
                    </Col>
                    <Col span={15} offset={1}>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width }}
                            value={data.contractRemittanceCompletedInfo}
                            onChange={value => onChange(value, 'contractRemittanceCompletedInfo')}
                        >
                            {RequestStatusOption}
                        </Select>
                    </Col>
                </Col>
            </Row>
        </div>
    );
}

export default UpdateView;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/UpdateView.js